module.exports = __webpack_public_path__ + "img/coming-soon.094109e0.svg";